import { useZocksQuota } from '../components/ScopedBlock/hooks'

export const useCustomWorkflowsEnabled = (): { enabled: boolean; isLoading: boolean } => {
  const { hasQuota, isFetching } = useZocksQuota()
  return { enabled: hasQuota('workflow.customWorkflowsEnabled.value'), isLoading: isFetching }
}
